// components/Footer.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-dark text-light py-4">
      <Container>
        <Row>
          <Col md={4}>
            <h5>Westron</h5>
            <p>App Development Company.</p>
          </Col>
          <Col md={2}>
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="/">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </Col>
          <Col md={3}>
            <h5>Dog Identifier</h5>
            <ul className="list-unstyled">
              <li><Link to="/dog-identifier" style={{ color: '#adb5bd', textDecoration: 'none' }}>App Page</Link></li>
              <li><Link to="/dog-identifier/privacy-policy" style={{ color: '#adb5bd', textDecoration: 'none' }}>Privacy Policy</Link></li>
              <li><Link to="/dog-identifier/terms" style={{ color: '#adb5bd', textDecoration: 'none' }}>Terms &amp; Conditions</Link></li>
            </ul>
          </Col>
          <Col md={3}>
            <h5>Connect</h5>
            <ul className="list-unstyled">
              <li><a href="https://facebook.com" target="_blank" rel="noreferrer">Facebook</a></li>
              <li><a href="https://twitter.com" target="_blank" rel="noreferrer">Twitter</a></li>
              <li><a href="https://linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a></li>
            </ul>
          </Col>
        </Row>
        <hr />
        <p className="text-center">&copy; {new Date().getFullYear()} Westron. All rights reserved.</p>
      </Container>
    </footer>
  );
}

export default Footer;